<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="border-0 col-9 mx-auto container-xl">
      <div class="title-area">
        <div class="d-flex">
          <h1 class="page-title">My profile</h1>
        </div>
        <span class="d-block"
          >{{ user.first_name }} {{ user.family_name }}</span
        >
      </div>
      <form @submit.prevent="profile_save">
        <div class="align-self-center" style="padding-top: 40px">
          <div class="mb-3">
            <label class="form-label" for="first-name">First name</label>
            <input
              id="first-name"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :disabled="!editing"
              v-model="user.first_name"
              autocomplete="given-name"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" for="family-name">Family name</label>
            <input
              id="family-name"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :disabled="!editing"
              v-model="user.family_name"
              autocomplete="family-name"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" for="email">E-mail</label>
            <input
              id="email"
              type="email"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :disabled="!editing"
              v-model="user.email"
              autocomplete="email"
            />
          </div>
          <!-- b-form-group label="Company Name">
              <input v-model="profile.company_name" class="form-control" />
            </div -->
          <div class="mb-3">
            <label class="form-label" for="address-1">Address</label>
            <input
              id="address-1"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :disabled="!editing"
              v-model="profile.address_1"
              autocomplete="address-line1"
            />
            <br />
            <input
              id="address-2"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :disabled="!editing"
              v-model="profile.address_2"
              autocomplete="address-line2"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" for="zip-code">Zip Code</label>
            <input
              id="zip-code"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :disabled="!editing"
              v-model="profile.zip_code"
              size="6"
              autocomplete="postal-code"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" for="city">City</label>
            <input
              id="city"
              :class="`form-control ${anon ? 'g-anon' : ''}`"
              :disabled="!editing"
              v-model="profile.city"
              autocomplete="address-level2"
            />
          </div>
          <div class="mb-3">
            <label class="form-label" for="country">Country</label>
            <select
              id="country"
              class="form-select"
              v-model="profile.country_id"
              :disabled="!editing"
            >
              <option
                v-for="option in countries_options"
                :key="option.value"
                :value="option.value"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-left py-3">
            <button
              v-if="!editing"
              class="btn btn-secondary"
              type="button"
              @click.prevent="editing = true"
            >
              Edit
            </button>
            <button v-if="editing" type="submit" class="btn btn-primary">
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import Navbar from "./Navbar.vue";
import Breadcrumb from "./Breadcrumb.vue";

const store = useStore();

const countries_options = ref([]);
const profile = ref({
  address_1: "",
  address_2: "",
  zip_code: "",
  city: "",
  country_id: null,
});
const editing = ref(false);
const user = ref({
  first_name: "",
  family_name: "",
  email: "",
});

const emptyProfile = () => ({
  address_1: "",
  address_2: "",
  zip_code: "",
  city: "",
  country_id: null,
});

const anon = computed(() => {
  return store.state.anon;
});

const countries_get = () => {
  countries_options.value = [];
  for (let i = 0; i < store.state.countries.length; i++) {
    const country = {
      value: store.state.countries[i].id,
      text: store.state.countries[i].country_name,
    };
    countries_options.value.push(country);
  }
};

const user_get = function () {
  store.dispatch("user_fetch").then(() => {
    if (store.state.user) {
      user.value = store.state.user;
    }
  });
};

const profile_get = function () {
  store.dispatch("profile_fetch").then((res) => {
    profile.value = { ...emptyProfile(), ...res.data };
  });
};

const parse_email = (email) => {
  // eslint-disable-next-line
  const pattern =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return pattern.test(email.toLowerCase());
};

const profile_save = async function () {
  await store.dispatch("profile_save", {
    user: user.value,
    profile: profile.value,
  });
  editing.value = false;
  user_get();
  profile_get();
};

onMounted(() => {
  countries_get();
  profile_get();
  user_get();
});
</script>

<style scoped>
.form-control,
.form-select {
  border-radius: 0;
}
</style>
